import * as owasp from 'owasp-password-strength-test';
import {
  MINIMUM_PASSWORD_LENGTH,
  MINIMUM_PASSWORD_STRENGTH_LEVEL,
  MAX_PASSWORD_STRENGTH_LEVEL,
} from './constants';

owasp.config({
  allowPassphrases: true,
  maxLength: 128,
  minLength: 10,
  minPhraseLength: 52,
  minOptionalTestsToPass: 4,
});

export function getPasswordStrengthLevel(password: string): number {
  if (!password) return 0;
  const result = owasp.test(password);
  return Math.min(result.optionalTestsPassed + 1, MAX_PASSWORD_STRENGTH_LEVEL);
}

export function getPasswordStrengthResult(password: string) {
  return owasp.test(password);
}

export function isPasswordValid(password: string): boolean {
  if (!password) return false;
  const strengthLevel = getPasswordStrengthLevel(password);
  return (
    password.length >= MINIMUM_PASSWORD_LENGTH &&
    strengthLevel >= MINIMUM_PASSWORD_STRENGTH_LEVEL
  );
}
